import { APP_INITIALIZER, ApplicationConfig, provideBrowserGlobalErrorListeners, provideZoneChangeDetection } from '@angular/core';
import { DATE_PIPE_DEFAULT_OPTIONS } from '@angular/common';
import { provideRouter } from '@angular/router';
import { provideHttpClient } from '@angular/common/http';
import { AppSettingService } from './services/app-setting.service';

import { routes } from './app.routes';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideHttpClient(),
    {
      provide: APP_INITIALIZER,
      useFactory: (svc: AppSettingService) => () => svc.load(),
      deps: [AppSettingService],
      multi: true,
    },
    {
      provide: DATE_PIPE_DEFAULT_OPTIONS,
      useFactory: (svc: AppSettingService) => ({ timezone: svc.timezone }),
      deps: [AppSettingService],
    },
  ]
};
